import React from 'react';
import { Button, Label, Table } from 'semantic-ui-react';
import { usePrintManifestAndPalletLabel } from 'hooks/usePrintManifestAndPalletLabel';

export default function ManifestItem({ manifest, setPrinting }) {
  const { printManifestAndPalletLabel } =
    usePrintManifestAndPalletLabel(setPrinting);

  return (
    <Table.Row>
      <Table.Cell>
        {manifest.reference}
        {manifest.is_mixed && (
          <Label color="teal" style={{ marginLeft: '1em' }}>
            Múltiples OP
          </Label>
        )}
      </Table.Cell>
      <Table.Cell textAlign="center">
        {manifest?.packages?.length || 0}
      </Table.Cell>
      <Table.Cell textAlign="right">
        <Button
          circular
          icon="print"
          onClick={(event, data) => printManifestAndPalletLabel(manifest)}
        />
      </Table.Cell>
    </Table.Row>
  );
}
